import { render, staticRenderFns } from "./Vsms.vue?vue&type=template&id=20333520"
import script from "./Vsms.vue?vue&type=script&lang=js"
export * from "./Vsms.vue?vue&type=script&lang=js"
import style0 from "./Vsms.vue?vue&type=style&index=0&id=20333520&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports